<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <div v-if="value.length > 1" class="text-xs-right acao-expandir-recolher">
            <v-btn v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-down</v-icon>
                Expandir Todos
            </v-btn>
            <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
                <v-icon left size="15">fas fa-chevron-up</v-icon>
                Recolher Todos
            </v-btn>
        </div>

        <v-expansion-panel v-model="paineis" expand class="painel-itens" :class="{ 'mt-3': value.length < 2}">
            <v-expansion-panel-content v-for="lote in value" :key="lote.id" class="painel-itens__linha cabecalho-painel">
                <template v-slot:header>
                    <p>
                        <strong>{{ lote.descricao }}</strong> -
                        <v-tooltip top v-if="lote.motivo">
                            <a slot="activator">
                                {{ lote.situacao | azEnum(situacoesItensELotes) }}
                                <i class="fas fa-comment" aria-hidden="true"/>
                            </a>
                            {{ lote.motivo }}
                        </v-tooltip>
                        <span v-else>
                            {{ lote.situacao | azEnum(situacoesItensELotes) }}
                        </span>
                    </p>
                    <div class="painel-itens__info">
                        <p>Exclusivo {{formatarLista(portes) | azConcat}}:</p>
                        <p class="ml-2">{{ lote.porteExclusivo ? 'Sim' : 'Não' }}</p>
                    </div>
                </template>

                <painel-lote-tabela v-model="lote.itens"
                                    :possuiValorReferencia="possuiValorReferencia"
                                    :exibirValorDeReferencia="exibirValorDeReferencia"
                                    :casasDecimais="casasDecimais"
                                    :casasDecimaisQuantidade="casasDecimaisQuantidade"
                                    :prefixOuSuffixValor="prefixSuffixValor"
                                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                    :criterioJulgamento="criterioJulgamentoDaCompra"/>

                <div class="total total-mobile" v-if="possuiValorReferencia && exibirValorDeReferencia">
                    <p>
                        <strong>{{!isCriterioJulgamentoMaiorDesconto ? 'Total Unitário:' : 'Desconto:'}}</strong> {{ lote.totalUnitario | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                    </p>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <div class="total total-listagem" v-if="!isCriterioJulgamentoMaiorDesconto && (value.length > 1 && possuiValorReferencia && exibirValorDeReferencia)">
            <p>
                <strong>Total:</strong> {{ total | cdCurrency(prefix, casasDecimais) }}{{suffix}}
            </p>
        </div>
    </v-flex>
</template>

<script>
import PainelLoteTabela from './PainelLoteTabela'
import {situacoesItensELotes} from '@/core/constants'

export default {
    name: 'PainelLoteVisualizacao',
    components: {
        PainelLoteTabela
    },
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        exibirValorDeReferencia: {},
        possuiValorReferencia: {},
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixSuffixValor:{
            type: String
        },
        criterioJulgamento:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    computed: {
        total() {
            let total = 0
            this.value.forEach(lote => {
                total += lote.totalUnitario
            })
            return total
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        },
        criterioJulgamentoDaCompra() {
            return this.criterioJulgamento
        }
    },
    mounted() {
        this.expandirTodos()
    },
    data() {
        return {
            paineis: [],
            ultimoEstadoPaineis: 'recolhido',
            totalmenteRecolhido: true,
            totalmenteExpandido: false,
            situacoesItensELotes
        }
    },
    methods: {
        expandirTodos() {
            const todosPaineisAbertos = this.value.map(() => {
                return true
            })
            this.paineis = todosPaineisAbertos
            this.totalmenteExpandido = true
            this.verificarUltimoEstado()
        },
        recolherTodos() {
            const todosPaineisFechados = this.value.map(() => {
                return false
            })
            this.paineis = todosPaineisFechados
            this.totalmenteExpandido = false
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        },
    },
    watch: {
        paineis() {
            let todosExpandidos = true
            let todosRecolhidos = true

            for (let posicao of this.paineis) {
                if (!posicao) {
                    todosExpandidos = false
                } else {
                    todosRecolhidos = false
                }
            }

            this.totalmenteExpandido = todosExpandidos
            this.totalmenteRecolhido = todosRecolhidos
            this.verificarUltimoEstado()
        }
    }
}
</script>

<style scoped lang="stylus">
    .painel-itens__info
        margin-right 20px

    @media (max-width 720px)
        .painel-itens__info
            margin-right 10px
</style>
